import React from "react"
import PropTypes from "prop-types"
import ClickHandler from "./ClickHandler"
import DropdownContainer from "./DropdownContainer"
import Label from "./Label"
import OptionsContainer from "./OptionsContainer"
import ShowSelection from "./ShowSelection"
import "./styles.css"

const Select = ({
  handleChange,
  name,
  label,
  selectOptions,
  value,
  className,
  ...props
}) => (
  <ClickHandler
    handleChange={handleChange}
    selectOptions={selectOptions}
    className={className || ""}
  >
    {(clickHandlerProps) => (
      <div className="row">
        <div className="col-lg-12">{label && <Label>{label}</Label>}</div>
        <div className="col-lg-12">
          <div className="select-container">
            <div className="select-box">
              <ShowSelection {...clickHandlerProps} {...props} value={value} />
              {clickHandlerProps.isVisible && (
                <DropdownContainer>
                  <OptionsContainer
                    {...clickHandlerProps}
                    name={name}
                    selectOptions={selectOptions}
                    selected={value}
                  />
                </DropdownContainer>
              )}
            </div>
          </div>
        </div>
      </div>
    )}
  </ClickHandler>
)

Select.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.string.isRequired),
  value: PropTypes.string,
  className: PropTypes.string,
}

export default Select
